import * as React from 'react';
import {AccountV2Icon} from 'src/icons/AccountV2Icon';
import {cn} from 'src/lib/utils';
import {logoUrl} from 'src/logoOptions';
import type {AccountListItemFragment} from '@transactions/graphql';

type Props = {
  account: AccountListItemFragment;
  /** Sizing/spacing for the badge; sized like a logo `<img>` (defaults to `size-4`). */
  className?: string;
};

/**
 * An account's visual identity: its logo when it has one, otherwise the
 * type-derived colored badge. Every place that shows an account alongside its
 * name renders this, so a logo and a fallback badge always occupy the same box.
 */
export const AccountAvatar = ({account, className}: Props) =>
  account.logo ? (
    <img
      src={logoUrl(account.logo)}
      alt=""
      className={cn('size-4 shrink-0 rounded-sm', className)}
    />
  ) : (
    <AccountV2Icon account={account} className={cn('shrink-0', className)} />
  );
